import Header from './components/Header';
import Intro from './components/Intro';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Consulting from './components/Consulting';
import Workshops from './components/Workshops';
import Brands from './components/Brands';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="dark">
      <div className="min-h-screen bg-black text-light">
        <Header />
        <main className="overflow-hidden max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Intro />
          <Skills />
          <Experience />
          <Consulting />
          <Workshops />
          <Brands />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
